export default __webpack_public_path__ + "static/media/Empty_State_16x9_2x.51294126.png";